import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import { Modal } from "react-bootstrap";

import AdminOrdersContext from "context/AdminOrdersContext.tsx";
import UserContext from "context/UserContext";
import { BsTrash } from "react-icons/bs";
import { BiDownArrow, BiUpArrow } from "react-icons/bi";
import { addCommas } from "@persian-tools/persian-tools";
import Accordion from "react-bootstrap/Accordion";
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
// accordion
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
const OrderModal: React.FC = () => {
  const { orderDetail, show, changeShow, editShow } =
    useContext(AdminOrdersContext);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  function timeMaker(time) {
    try {
      let d = new Date(parseInt(mtm) * 1000);
      let perTm = toJalaali(d);
      return `${perTm.jy}/${perTm.jm < 10 ? 0 : ""}${perTm.jm}/${
        perTm.jd < 10 ? 0 : ""
      }${perTm.jd}  ${d.getHours() < 10 ? "0" : ""}${d.getHours()}:${
        d.getMinutes() < 10 ? "0" : ""
      }${d.getMinutes()}`;
    } catch (ex) {
      return "";
    }
  }
  const timestampToDate = (time) => {
    const a = time * 1000;
    const date = new DateObject({ date: a, calendar: persian });
    const b = new Date(a);
    return date.format();
  };

  // console.log("orderDetail", orderDetail);
  return (
    <>
      <Modal
        className="order-modal"
        fullscreen
        show={show}
        onHide={() => changeShow()}
      >
        <Modal.Header className="" closeButton></Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f3eeea" }}>
          <div className="d-flex flex-wrap justify-content-evenly py-3">
            {orderDetail && (
              <div
                className="px-2   my-1 col-11 col-lg-3 col-md-2 side shadowAdmin d-flex  flex-wrap justify-content-between py-5"
                style={{
                  fontSize: "12px",
                  height: "auto",
                }}
              >
                <div className="d-flex flex-wrap text-center col-md-12 col-sm-4 col-6 my-1">
                  <div className="col-lg-6 col-12">شماره سفارش:</div>
                  <div
                    style={{ fontFamily: "normal" }}
                    className="col-lg-6 col-12 "
                  >
                    {orderDetail.id}
                  </div>
                </div>
                <div className="d-flex text-center col-md-12 col-sm-4 col-6 flex-wrap my-1">
                  <div className="col-lg-6 col-12"> تاریخ سفارش:</div>
                  <div
                    className="col-lg-6 col-12"
                    style={{ fontFamily: "normal" }}
                  >
                    {" "}
                    {timestampToDate(orderDetail.mtm)}
                  </div>
                </div>
                <div className="d-flex text-center col-md-12 col-sm-4 col-6 flex-wrap">
                  <div className="col-lg-6 col-12"> نام فروشگاه:</div>
                  <div
                    className="col-lg-6 col-12"
                    style={{ fontFamily: "normal" }}
                  >
                    --
                  </div>
                </div>
                <div className="d-flex text-center col-md-12 col-sm-4 col-6 flex-wrap my-1">
                  <div className="col-lg-6 col-12"> نام کاربر:</div>
                  <div
                    className="col-lg-6 col-12"
                    style={{ fontFamily: "normal" }}
                  >
                    {orderDetail.user_info[0].fullname == ""
                      ? "--"
                      : orderDetail.user_info[0].fullname}
                  </div>
                </div>
                <div className="d-flex text-center col-md-12 col-sm-4 col-6 flex-wrap my-1">
                  <div className="col-lg-6 col-12"> شماره تماس:</div>
                  <div
                    className="col-lg-6 col-12"
                    style={{ fontFamily: "normal" }}
                  >
                    {orderDetail.user_info[0].mobile == ""
                      ? "--"
                      : orderDetail.user_info[0].mobile}
                  </div>
                </div>
                <div className="d-flex text-center  col-md-12 col-12 flex-wrap my-1">
                  <div className="col-lg-6 col-12"> آدرس تحویل:</div>
                  <div
                    className="col-lg-6 col-12 address"
                    style={{ fontFamily: "normal" }}
                  >
                    {orderDetail.address_info[0].address == ""
                      ? "--"
                      : orderDetail.address_info[0].address}
                  </div>
                </div>
              </div>
            )}
            <div className="col-11 my-1 col-lg-8 col-md-9 shadowAdmin">
              <Accordion defaultActiveKey="0">
                {" "}
                {orderDetail?.items.map((value, index) => (
                  <OrderItem
                    details={value}
                    key={`order-item${index}`}
                    index={index}
                  />
                ))}
              </Accordion>

              <div className="borderTop-modal d-flex justify-content-between mx-4 py-2 px-4">
                <div>هزینه ارسال:</div>
                <div>ثابته</div>
              </div>
              <div className="borderTop-modal mx-4 py-2  d-flex flex-wrap align-items-center">
                <p className="col-md-5 col-sm-7 col-11 text-start ps-4">
                  مجموع
                </p>
                <p className="col-md-1 col-sm-2 col-2 text-center">
                  {orderDetail?.items.length} عدد
                </p>
                <p className="col-md-2 col-sm-2 col-4 text-center">
                  {addCommas(orderDetail?.total_price)}
                </p>
                <p className="col-md-2 col-sm-6 col-4 text-center text-danger">
                  {addCommas(orderDetail?.total_discount)}
                </p>
                <p
                  className="col-md-2 col-sm-6 col-4 text-center py-1"
                  style={{
                    backgroundColor: "#02a50d",
                    color: "white",
                    borderRadius: 10,
                  }}
                >
                  {addCommas(
                    +orderDetail?.total_price - +orderDetail.total_discount
                  )}
                </p>
              </div>
              {superAdminOrders && (
                <div className="borderTop-modal d-flex align-items-center justify-content-between mx-4 py-2 flex-wrap">
                  <div className="d-flex col-5 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">کمیسیون دریافتِ:</div>
                    <div className="border border-success col-5 py-1  rounded">
                      ثابت
                    </div>
                  </div>

                  <div className="d-flex col-xl-5 col-lg-7 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">پرداختی نهایی به فروشگاه:</div>
                    <div className="border border-danger col-5 py-1 rounded">
                      ثابت
                    </div>
                  </div>
                  <div className="d-flex col-5 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">پرداختی بابت پیک:</div>
                    <div className="border border-danger col-5 py-1 rounded">
                      ثابت
                    </div>
                  </div>
                </div>
              )}
              {!superAdminOrders && !customerOrders && (
                <div className="borderTop-modal d-flex align-items-center justify-content-between mx-4 py-2 flex-wrap">
                  <div className="d-flex col-5 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">کارمزد پرداختی:</div>
                    <div className="border border-success col-5 py-1  rounded">
                      ثابت
                    </div>
                  </div>

                  <div className="d-flex col-xl-5 col-lg-7 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">دریافت نهایی فروشگاهاه:</div>
                    <div className="border border-success col-5 py-1 rounded">
                      ثابت
                    </div>
                  </div>
                </div>
              )}
              {customerOrders && (
                <div className="borderTop-modal d-flex align-items-center justify-content-between mx-4 py-2 flex-wrap">
                  <div className="d-flex col-5 col-sm-6 col-12 align-items-center my-2">
                    <div className="col-5">سود شما از خرید:</div>
                    <div className="border border-success col-5 py-1  rounded">
                      ثابت
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

function OrderItem({ details, index }) {
  const { editShow } = useContext(AdminOrdersContext);
  function ContextAwareToggle({ children, eventKey, callback }) {
    // const { activeEventKey } = useContext(AccordionContext);
    const { activeEventKey } = index;

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <button
        type="button"
        className="border-0 ms-auto"
        // style={{ backgroundColor: isCurrentEventKey ? "pink" : "lavender" }}
        onClick={decoratedOnClick}
      >
        {children}
      </button>
    );
  }
  return (
    <div className="mb-3">
      <div className="order-item d-flex flex-wrap align-items-center rounded mt-3 mx-4 ">
        {/* <div className="card-img-top">
        <img src={"http://sabadi.tatdemo.ir/" + details.path} alt="Product" />
      </div> */}
        <div className="col-xl-1 col-sm-2 col-3 p-2">
          <img
            src={"http://sabadi.tatdemo.ir/" + details.path}
            alt="Product"
            className="pro-img shadow p-1  "
          />
        </div>

        <div className=" col-xl-4 col-md-3 col-sm-5 col-8 my-2">
          <div className="card-title">شرح محصول</div>
          <div className="">
            {details.product_title == "" ? "--" : details.product_title}
          </div>
        </div>
        <div className=" col-md-1 col-sm-2 col-2 my-2">
          <div className="card-title">تعداد</div>
          <div>{details.item_count == "" ? "--" : details.item_count}</div>
        </div>
        <div className="col-md-2 col-sm-2 col-5 my-2">
          <div className="card-title">قیمت</div>
          <div>
            {addCommas(details.product_price == "" ? 0 : details.product_price)}{" "}
            تومان
          </div>
        </div>
        <div className=" col-md-2 col-sm-6 col-5 my-2">
          <div className="card-title">تخفیف</div>

          <div className="card-text">
            {addCommas(details.discount == "" ? 0 : details.discount)}
          </div>
        </div>
        <div className=" col-md-2 col-sm-6 col-12 my-2">
          <div className="card-title"> مبلغ قابل پرداخت</div>
          <div>{addCommas(details.product_price - details.discount)}</div>
        </div>
        {details.rto_basket_id != "0" && (
          <ContextAwareToggle eventKey={index}>
            <BiDownArrow />
          </ContextAwareToggle>
        )}

        {/* {editShow ? (
        <div className="changeCount">
          <Form.Control
            type="number"
            min="1"
            max="20"
            placeholder={details.count}
          />
          <div>
            <BsTrash
              style={{
                width: "20px",
                height: "20px",
                float: "left",
                marginTop: "10px",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      ) : (
        ""
      )} */}
      </div>

      <Accordion.Collapse eventKey={index}>
        <div
          className="mx-4 px-2"
          style={{
            backgroundColor: "rgb(243, 238, 234)",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          }}
        >
          {details.rto_basket_id != "0" &&
            details.items.map((v, i) => {
              return (
                <>
                  {v.product_title}&nbsp;
                  {addCommas(v.product_price)}تومان ({v.item_count}عدد)
                  {i != v.length - 1 && "،"}
                </>
              );
            })}
        </div>
      </Accordion.Collapse>
    </div>
  );
}

export default OrderModal;
